import { formatDate } from "_helper/utils";
import { FORM_ERROR_MESSAGES } from "Constant";
import { useMasterLocation } from "hook/useMasterLocation";
import { genderOptions } from "pages/users/constant";
import { TableColumn } from "react-data-table-component";
import { UseFormReturn } from "react-hook-form";

export const useListTableColumns = () => {
  const tableColumns: TableColumn<any>[] = [
    {
      name: "Ảnh",
      selector: ({ image }) => (
        <img
          src={image}
          className="h-10 w-10 rounded-full"
          alt=""
          onError={(e) => {
            e.currentTarget.src = "https://www.gravatar.com/avatar/?d=mp";
          }}
        />
      ),
    },
    {
      name: "CCCD",
      selector: ({ cccd }) => cccd || "",
    },
    {
      name: "Họ và Tên",
      selector: ({ hoVaTen }) => hoVaTen || "",
    },
    {
      name: "Ngày sinh",
      selector: ({ ngaySinh }) => formatDate(ngaySinh),
    },
    {
      name: "Địa chỉ",
      selector: ({ diaChi }) => diaChi || "",
    },
    {
      name: "Số lần vi phạm",
      selector: ({ soLanViPham }) => soLanViPham || "",
    },
    {
      name: "Thời gian tạo",
      selector: ({ thoiGianTao }) => formatDate(thoiGianTao),
    },
    {
      name: "Người tạo",
      selector: ({ nguoiTao }) => nguoiTao || "",
    },
    {
      name: "Người chỉnh sửa",
      selector: ({ nguoiChinhSua }) => nguoiChinhSua || "",
    },
  ];
  return { tableColumns };
};

export const useFormFields = (useFormReturn?: UseFormReturn) => {
  const { watch } = useFormReturn || {};
  const { formFields } = useMasterLocation({
    quanHuyen: watch?.("masterQuanHuyenId"),
    tinhThanhPho: watch?.("masterTinhThanhPhoId"),
  });

  return [
    {
      name: "hoVaTen",
      label: "Họ và tên",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "soLanViPham",
      label: "Số lần vi phạm",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "ngaySinh",
      label: "Ngày sinh",
      type: "date",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "gioiTinh",
      label: "Giới tính",
      type: "radio",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
      options: genderOptions,
    },
    {
      name: "cccd",
      label: "Số CCCD",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
        pattern: {
          value: /^\d{12}$/,
          message: "CCCD phải có 12 chữ số",
        },
      },
    },
    {
      name: "ngayCapCCCD",
      label: "Ngày cấp CCCD",
      type: "date",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "noiCapCCCD",
      label: "Nơi cấp CCCD",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "soDienThoai",
      label: "Số điện thoại",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
        pattern: {
          value: /^[0-9]{10,11}$/,
          message: "Số điện thoại không hợp lệ",
        },
      },
    },
    {
      name: "diaChi",
      label: "Địa chỉ",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    ...formFields,
    {
      name: "ghiChu",
      label: "Ghi chú",
      type: "text",
    },
  ] as any;
};

export const title = "Danh sách đối tượng vi phạm";
export const parent = "Đối tượng vi phạm";
